import ROSTER_UI_SCHEMA from '../rosterUiSchema';
import { ROSTER_COLUMN_DESCRIPTIONS } from '../constants';
import config from '../../config';

import rosterHeaderUrl from './rosterHeaderComponent.html';

class RosterHeaderCtrl {
  columnDescriptions = ROSTER_COLUMN_DESCRIPTIONS;

  constructor(Authentication, RosterService, dateFilter, toSubscriptionNameFilter, $rootScope) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      RosterService,
      dateFilter,
      toSubscriptionNameFilter,
      $rootScope,
    });
    this.FORCE_SCHEDULE_AUTOSYNC_OFF = config.FORCE_SCHEDULE_AUTOSYNC_OFF;
    this.DISABLING_SCHEDULE_AUTOSYNC_ENABLED = Array.isArray(
      config.DISABLING_SCHEDULE_AUTOSYNC_ENABLED
    )
      ? config.DISABLING_SCHEDULE_AUTOSYNC_ENABLED.includes(this.Authentication.user.org.id)
      : config.DISABLING_SCHEDULE_AUTOSYNC_ENABLED;
  }

  get date() {
    return this.RosterService.date;
  }

  set date(value) {
    this.RosterService.date = value;
    this.refresh();
  }

  get filtersOpened() {
    return this.RosterService.filtersOpened;
  }

  set filtersOpened(value) {
    this.RosterService.setFiltersOpened(value);
  }

  $onInit() {
    this._setColumnsSchema();
  }

  _setColumnsSchema() {
    this.schema = { ...ROSTER_UI_SCHEMA.table };

    const disabledStatusSuffix = !this.Authentication.isOrgFeatureEnabled('clockIn')
      ? `available in ${this.toSubscriptionNameFilter('clockIn')}.`
      : 'disabled in settings';
    const statusColumn = this.schema.items.find((c) => c.propert === 'status');
    const tagsColumn = this.schema.items.find((c) => c.property === 'tags');

    if (statusColumn) {
      statusColumn.disabledDescription = `Time clock is ${disabledStatusSuffix}`;
    }

    if (tagsColumn) {
      tagsColumn.disabledDescription = this.Authentication.isOrgFeatureEnabled('tags')
        ? 'Add tags to this organization.'
        : `Tags are available in ${this.toSubscriptionNameFilter('tags')}.`;
    }
  }

  getDisplayHeaderDate() {
    return this.dateFilter(this.RosterService.date, 'EEE • dd MMMM');
  }

  filtersEmpty() {
    return this.RosterService.filtersEmpty;
  }

  changeGroupMethod(value) {
    this.RosterService.changeGroupMethod(value);
    this.onGroupMethodChange();
  }

  onFiltersChange() {
    this.changeFilters();
    this.RosterService.onFiltersChange();
  }

  canDataColumnBeVisible(column) {
    if (!this.columns) {
      return true;
    }

    const col = this.columns.reportColumns.find((c) => c.property === column);
    return !col || !this.shouldHideColumn({ column: col });
  }

  onColumnsChange() {
    this.$rootScope.$broadcast('vsRepeatTrigger');
    this.columns.changed();
  }
}

export default {
  templateUrl: rosterHeaderUrl,
  controller: RosterHeaderCtrl,
  controllerAs: 'ctrl',
  bindings: {
    columns: '<',
    hasEvents: '<',
    rosterHasPendingChanges: '<',
    onGroupMethodChange: '&',
    changeFilters: '&',
    getDataForExport: '&',
    shouldHideColumn: '&',
    getPrintPayload: '&',
    refresh: '&',
  },
};
